<template>
	<div
		v-ripple
		class="ao-select-item d-flex"
		:class="[
			{ 'ao-select-item_active': active },
			{ 'ao-select-item_with-text': itemText },
			{ 'ao-select-item_disabled': disabled },
		]"
		@click="$emit('click')"
	>
		<AoCheckbox
			v-if="isCheckboxDisplay"
			class="ao-select-item__checkbox"
			:modelValue="active"
			readonly
			isLabelMultiRow
			identRight
			@update:modelValue="$emit('click')"
		/>

		<div class="d-flex flex-1-1 align-center">
			<div
				v-if="isShowPrepend"
				class="ao-select-item__prepend"
			>
				<slot name="prepend">
					<AoAvatar
						v-if="prependAvatar"
						class="ao-select-item__avatar-prepend"
						:image="prependAvatar"
						imageCover
						rounded="lg"
						:size="36"
					/>
					<AoIcon
						v-if="prependIcon"
						class="ao-select-item__icon-prepend"
						:iconName="prependIcon"
						size="large"
					/>
				</slot>
			</div>

			<div class="ao-select-item__info">
				<span class="ao-select-item__title">
					{{ title }}
				</span>

				<span
					v-if="subtitle"
					class="ao-select-item__subtitle"
				>
					{{ subtitle }}
				</span>

				<span
					v-if="itemText"
					class="ao-select-item__itemText"
				>
					{{ itemText }}
				</span>
			</div>

			<div
				v-if="isShowAppend"
				class="ao-select-item__append"
			>
				<slot name="append">
					<AoIcon
						v-if="appendIcon"
						class="ao-select-item__icon-append"
						:iconName="appendIcon"
						size="large"
					/>
					<AoAvatar
						v-if="appendAvatar"
						class="ao-select-item__avatar-append"
						:image="appendAvatar"
						imageCover
						rounded="lg"
						:size="36"
					/>
				</slot>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, useSlots } from 'vue'
import AoAvatar from './AoAvatar.vue'
import AoCheckbox from './AoCheckbox.vue'
import AoIcon from './AoIcon.vue'

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	subtitle: {
		type: String,
	},
	itemText: {
		type: String,
	},
	prependAvatar: {
		type: String,
		default: null,
	},
	prependIcon: {
		type: String,
		default: null,
	},
	appendAvatar: {
		type: String,
		default: null,
	},
	appendIcon: {
		type: String,
		default: null,
	},
	active: {
		type: Boolean,
	},
	disabled: {
		type: Boolean,
	},
	isCheckboxDisplay: {
		type: Boolean,
	},
})

defineEmits({
	click: null,
})

const slots = useSlots()

const isShowPrepend = computed(() => {
	if (props.prependIcon || props.prependAvatar || slots.prepend) return true

	return false
})

const isShowAppend = computed(() => {
	if (props.appendIcon || props.appendAvatar || slots.append) return true

	return false
})
</script>

<style lang="scss">
.ao-select-item {
	$root: &;

	font-weight: 500;
	font-size: 14px;
	padding: 8px 12px;
	border-radius: 8px;
	align-items: center;
	cursor: pointer;

	&_active,
	&:hover {
		background-color: rgb(var(--v-theme-primary-50));
	}

	&_disabled &_active {
		background-color: rgba(var(--v-theme-default), 5%);
	}

	&__info {
		display: flex;
		flex-direction: column;
	}

	&_disabled {
		color: #b6bbc2;
		pointer-events: none;
		#{$root}__title {
			color: #86919d;
		}
	}

	&__title {
		color: #1d2126;
	}

	&__subtitle,
	&__itemText {
		color: #86919d;
	}

	&__itemText {
		font-size: 12px;
	}

	&_with-text {
		align-items: normal;
		#{$root}__checkbox {
			margin-top: 10px;
		}
	}

	&__append {
		margin-left: auto;
	}

	&__prepend {
		margin-right: 8px;
	}
}
</style>
